import React from 'react'
import PropTypes from 'prop-types'
import './card.css'

const Card = (props) => {
  return (
    <div className={`card-container1 ${props.rootClassName}`}>
      <div className="card-container2">
        <div className="card-badge">⚡ Returning clients</div>
        <h1>Experience lightning-fast cash deposits.</h1>
        <span>
          With a HelpMeOut debit card, returning clients can access their funds almost instantly — no waiting, no hassle.
        </span>
      </div>
      <div className="card-video-wrapper">
        <video className="card-video" src="/rotating-card.webm" autoPlay loop muted playsInline />
      </div>
    </div>
  )
}

Card.defaultProps = { rootClassName: '' }
Card.propTypes = { rootClassName: PropTypes.string }

export default Card
